import React from 'react';
import styled from 'styled-components';
import { IRowMeta } from '../../../../redux/slices/oldBuilder';
import { IMeasureFunction } from '../../../../utils/apollo/graphqlSchema';
import MeasureFunction from '../MeasureFunction';
import { EventConditions } from '../../BuilderFields';
import { theme } from '../../../../styles/theme';

interface IProps {
  rowMeta: IRowMeta;
  measureFunctions: IMeasureFunction[];
}

const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 318px 1fr;
  column-gap: 8px;
  align-items: start;
  padding: 8px 16px;
  border-top: 1px solid ${theme.colors.border};
`;

const MeasureRowContent = ({ rowMeta, measureFunctions }: IProps) => (
  <Container>
    <MeasureFunction rowMeta={rowMeta} measureFunctions={measureFunctions} />
    <EventConditions
      rowMeta={rowMeta}
      label={'Event(s)'}
      showLabelPerCondition
    />
  </Container>
);

export default MeasureRowContent;
